export default __webpack_public_path__ + "static/media/login_bg_fasting@3x.c476bcfc.jpg";